import { useEffect, useState } from 'react';

import { findExistingMembers } from '../../../services';

/**
 * Whether another member of the workspace already uses `email` (the mock members service answers;
 * the member being edited does not count). Only a valid, non-empty address is looked up. The
 * answer belongs to the address it was asked for, so a stale one never applies to newer text.
 *
 * @param {string} email Trimmed address being typed.
 * @param {string} memberId The member whose email is edited.
 * @param {boolean} enabled False skips the lookup (empty or invalid text).
 * @returns {boolean}
 */
export const useEmailTaken = (email, memberId, enabled) => {
  const [answer, setAnswer] = useState({ email: '', taken: false });

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    findExistingMembers([email])
      // Only the lookup is caught (the service still rejects a duplicate when the email is saved).
      .catch(() => null)
      .then((res) => {
        if (cancelled || !res) return;
        const items = res.body?.items ?? [];
        setAnswer({ email, taken: items.some((m) => m.id !== memberId) });
      });
    return () => {
      cancelled = true;
    };
  }, [email, memberId, enabled]);

  return enabled && answer.email === email && answer.taken;
};
